/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Compax Frontend API-v2
 * API by Compax
 * OpenAPI spec version: 161.0.0-SNAPSHOT
 */

export type DrCreditCardCardType =
  (typeof DrCreditCardCardType)[keyof typeof DrCreditCardCardType];

export const DrCreditCardCardType = {
  TWI: "TWI",
  PFC: "PFC",
  ECA: "ECA",
  VIS: "VIS",
} as const;
